import {fetch, normalize} from "utils/dataAccess";

// The brands collection is intentionally light, so the edit form fetches the full item (translations,
// ctaLinks, content) through this call. `normalize(retrieved, false)`: keep nested documents (the
// picture media objects carry the contentUrl the form previews) instead of flattening them to IRIs.
export default async function get(brandIri) {
    const response = await fetch(brandIri);

    return normalize(await response.json(), false);
}
